<script lang="ts">
  import { clearErrors, dismissError, getErrors } from '$lib/stores/errors.svelte';
  import Toast from './Toast.svelte';

  const errors = $derived(getErrors());
</script>

<div class="toasts">
  {#each errors as entry (entry.id)}
    <Toast {entry} ondismiss={() => dismissError(entry.id)} />
  {/each}
  {#if errors.length > 1}
    <button class="dismiss-all" onclick={clearErrors}>
      Dismiss all ({errors.length})
    </button>
  {/if}
</div>

<style>
  .toasts {
    position: fixed;
    right: var(--sp-4);
    bottom: var(--sp-4);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: var(--sp-2);
    pointer-events: none;
  }
  .toasts > :global(*) {
    pointer-events: auto;
  }
  .dismiss-all {
    align-self: flex-end;
    font-size: var(--fs-xs);
    background: var(--bg-primary);
    color: var(--text-primary);
    border: 1px solid var(--border-node);
    border-radius: 3px;
    padding: 2px 8px;
    cursor: pointer;
  }
  .dismiss-all:hover {
    border-color: var(--accent-error);
  }
</style>